import React from "react";
import "./Guide.css";
import BackBtn from "../../Components/BackBtn/BackBtn";

export default function Guide() {
  return (
    <div className="gymBg bgContainer">
      <div className="blurOverlay">
        <div className="pageWrapper">
          <div className="pageHeader centeredFlex">
            <BackBtn />
          </div>
          <div className="pageTitle horizontalBorder">REDROSE</div>
          <div className="guideContent centeredFlex">
            <p>
              سال 1400 با هدف فعالیت در زمینه ی ورزش و تغذیه در جهت تناسب اندام
              و ارتقای سلامتی به عنوان جامع ترین سوپر اپلیکیشن تناسب اندام ایران
              و خاورمیانه، با کلاس های آنلاین و زنده راه اندازی شد. ما با همراهی
              مربی های مجرب و همچنین با در نظر گرفتن بخش های مختلف از قبیل
              «بدنسازی» «پیلاتس» «یوگا» و «مربی خودت باش» سعی داریم تمام اهداف
              شما را در زمینه تناسب اندام و سلامتی، پوشش دهیم.
            </p>
            <img
              src="/images/coloredLogo.svg"
              alt="logo"
              className="coloredLogo"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
